import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';

import withIntl from '../../lib/withIntl';

import './TrayCalibrationControlPanel.scss';
import {TouchProbeGuideTooltip} from '../../components/TouchProbeGuideImage';
import MotionControlPad from '../PlateTypeEditor/MotionControlPad';

const trayInsertNumber = [1, 2, 3, 4, 5, 6];

function TrayCalibrationControlPanel({
  onRetractTouchProbe,
  onExtendTouchProbe,
  onSelectDeck,
  selectedDeckInsert,
  onHoming,
  onSetValueMotionPad,
  onClickArrow,
  deckInsertID,
  xVal,
  yVal,
  zVal,
  intl,
}) {
  console.log('');
  return (
    <div className="tray-calibration-control-panel">
      <div className="tray-calibration-control-panel__section">
        <div className="tray-calibration-control-panel__section__header">
          {intl.formatMessage({id: 'trayCalibrationContainer.trayInsertSelection.label'})}
        </div>
        <div className="tray-calibration-control-panel__section__body tray-insert-number">
          {trayInsertNumber.map((id) => (
            <div
              key={id}
              className={`tray-insert-number__item ${selectedDeckInsert === id ? 'selected' : ''}`}
              onClick={() => onSelectDeck(id)}
              role="presentation"
            >
              {id}
            </div>
          ))}
        </div>
      </div>

      <div className="tray-calibration-control-panel__section">
        <div className="tray-calibration-control-panel__section__header">
          {intl.formatMessage({id: 'trayCalibrationContainer.touchProbeControl.label'})}
          <TouchProbeGuideTooltip tooltipStyle={{opacity: '100%', marginLeft: '-30px'}} />
        </div>
        <div className="tray-calibration-control-panel__section__body touch-probe-control">
          <Button type="button" bsStyle="primary" className="touch-probe-control__button" onClick={onRetractTouchProbe}>
            {intl.formatMessage({id: 'trayCalibrationContainer.touchProbeControl.buttonRetract'})}
            <span className="glyphicon glyphicon-triangle-top" />
          </Button>
          <Button type="button" bsStyle="primary" className="touch-probe-control__button" onClick={onExtendTouchProbe}>
            {intl.formatMessage({id: 'trayCalibrationContainer.touchProbeControl.buttonExtend'})}
            <span className="glyphicon glyphicon-triangle-bottom" />
          </Button>
        </div>
      </div>

      <div className="tray-calibration-control-panel__section">
        <div className="tray-calibration-control-panel__section__header">
          {intl.formatMessage({id: 'trayCalibrationContainer.motionControlPad.label'})}
        </div>
        <div className="tray-calibration-control-panel__section__body">
          <div className="motion-control-pad">
            <MotionControlPad
              moveValue={0}
              style={{marginBottom: '10px'}}
              onClickArrow={onClickArrow}
              useDefaultErrorHandler={false}
              withExtendedTouchProbe={false}
            />
            <Button type="button" className="motion-control-pad__button recover button-secondary" onClick={onHoming}>
              {intl.formatMessage({id: 'trayCalibrationContainer.motionControlPad.buttonRecover'})}
            </Button>
          </div>

          <div className="current-position">
            <div className="current-position__header">
              {intl.formatMessage({id: 'trayCalibrationContainer.currentPosition.label'})}
            </div>
            <div className="current-position__body">
              <div className="current-position__item">
                <span>
                  X: &nbsp;
                  <strong>{xVal}</strong>
                  &nbsp; mm
                </span>
              </div>
              <div className="current-position__item">
                <span>
                  Y: &nbsp;
                  <strong>{yVal}</strong>
                  &nbsp; mm
                </span>
              </div>
              <div className="current-position__item">
                <span>
                  Z: &nbsp;
                  <strong>{zVal}</strong>
                  &nbsp; mm
                </span>
              </div>
              <Button
                className={`current-position__button ${deckInsertID === 0 ? 'disabled' : ''}`}
                type="button"
                disabled={deckInsertID === 0}
                onClick={onSetValueMotionPad}
              >
                <span>{intl.formatMessage({id: 'trayCalibrationContainer.motionControlPad.buttonSetValue'})}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

TrayCalibrationControlPanel.propTypes = {
  onRetractTouchProbe: PropTypes.func.isRequired,
  onExtendTouchProbe: PropTypes.func.isRequired,
  onSelectDeck: PropTypes.func.isRequired,
  selectedDeckInsert: PropTypes.number.isRequired,
  onHoming: PropTypes.func.isRequired,
  onSetValueMotionPad: PropTypes.func.isRequired,
  onClickArrow: PropTypes.func.isRequired,
  deckInsertID: PropTypes.number.isRequired,
  xVal: PropTypes.number.isRequired,
  yVal: PropTypes.number.isRequired,
  zVal: PropTypes.number.isRequired,
  intl: PropTypes.any.isRequired,
};

export default withIntl(TrayCalibrationControlPanel);
